import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';

// Corrected component imports
import Navbar from "./Componet/Navbar";  
import Home from "./Componet/Home";
import About from "./Componet/about";
import Service from "./Componet/Service";  
import Ourwork from "./Componet/Ourwork";  
import Clients from "./Componet/Clients"; 
import Contact from "./Componet/Contact";
import Footer from "./Componet/Footer";
import MeetOurClients from "./Componet/MeetOurClients";
import Loader from "./loader/Loader"; // ✅ Import Loader component
import ScrollToTop from "./Componet/ScrollToTop";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Service />} />
            <Route path="/ourwork" element={<Ourwork />} />  
            <Route path="/Clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </>
      )}
    </>
  );
}

export default App;